import React, { Fragment, useEffect, useState } from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import EndCallButton from '../Buttons/EndCallButton/EndCallButton';
import { isMobile } from '../../utils';
import Menu from './Menu/Menu';
import useParticipants from '../../hooks/useParticipants/useParticipants';
import useRoomState from '../../hooks/useRoomState/useRoomState';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';
import { Typography, Grid, Hidden, MenuItem, styled } from '@material-ui/core';
import ToggleAudioButton from '../Buttons/ToggleAudioButton/ToggleAudioButton';
import ToggleChatButton from '../Buttons/ToggleChatButton/ToggleChatButton';
import ToggleVideoButton from '../Buttons/ToggleVideoButton/ToggleVideoButton';
import ToggleScreenShareButton from '../Buttons/ToogleScreenShareButton/ToggleScreenShareButton';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Dailpad from '../DailPad/DailPad';
import './Menu.css';
import ParticipantsList from '../ParticipantsList/ParticipantsList';
import useChatContext from '../../hooks/useChatContext/useChatContext';
import Dailer from '../Assets/dailer.png';
import SMS from '../Assets/sms.png';
import Participants from '../Assets/participant.png';
import Record from '../Assets/record.png';
import Logo from '../Assets/Logo.png';
import SmsInvite from '../DailPad/SmsInvite';
import OpenCallOrSms from '../OpenCallOrSms/OpenCallOrSms';
import { useAppState } from '../../state';

import { useParams, useLocation, useHistory } from 'react-router-dom';
import StartRecordingIcon from '../../icons/StartRecordingIcon';
import useIsRecording from '../../hooks/useIsRecording/useIsRecording';
import StopRecordingIcon from '../../icons/StopRecordingIcon';
function OpenSmsorCallModal(data: string) {
  return <div>Hello </div>;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      backgroundColor: theme.palette.background.default,
      bottom: 0,
      left: 0,
      right: 0,
      height: `${theme.footerHeight}px`,
      position: 'fixed',
      display: 'flex',
      padding: '0 1.43em',
      zIndex: 10,
      [theme.breakpoints.down('sm')]: {
        height: `${theme.mobileFooterHeight}px`,
        padding: 0,
      },
    },
    screenShareBanner: {
      position: 'fixed',
      zIndex: 8,
      bottom: `${theme.footerHeight}px`,
      left: 0,
      right: 0,
      height: '104px',
      background: 'rgba(0, 0, 0, 0.5)',
      '& h6': {
        color: 'white',
      },
      '& button': {
        background: 'white',
        color: theme.brand,
        border: `2px solid ${theme.brand}`,
        margin: '0 2em',
        '&:hover': {
          color: '#600101',
          border: `2px solid #600101`,
          background: '#FFE9E7',
        },
      },
    },
    hideMobile: {
      display: 'initial',
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
  })
);
export const IconContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  width: '1.5em',
  marginRight: '0.3em',
});
export default function MenuBar() {
  const classes = useStyles();
  const isRecording = useIsRecording();
  const history = useHistory();
  const [userIsMobile, setUserIsMobile] = useState(true);
  const { isFetching, updateRecordingRules, roomType, setIsGalleryViewActive, isGalleryViewActive } = useAppState();
  const { isSharingScreen, toggleScreenShare } = useVideoContext();
  const roomState = useRoomState();
  const isReconnecting = roomState === 'reconnecting';
  const { room } = useVideoContext();
  const participants = useParticipants();
  const [isDialpadModalOpen, setIsDialpadModalOpen] = useState<boolean>(false);
  const [isOpenCallOrSms, setIsOpenCallOrSms] = useState<boolean>(false);
  const [NumberAvailable, setNumberAvailable] = useState<boolean>(true);
  const [isSmsModalOpen, setIsSmsModalOpen] = useState<boolean>(false);
  const [isListOpen, setisListOpen] = useState<boolean>(false);
  const { messages } = useChatContext();
  const { search, state } = useLocation();
  const ContactPhoneNumber = (state as { state: { ContactPhoneNumber: string } }).state.ContactPhoneNumber;
  const RecordId = (state as { state: { RecordId: string } }).state.RecordId;
  const ContactName = (state as { state: { ContactName: string } }).state.ContactName;
  const ProviderId = (state as { state: { ProviderId: string } }).state.ProviderId;
  const Type = (state as { state: { Type: string } }).state.Type;
  useEffect(() => {
    window.innerWidth < 480 ? setUserIsMobile(true) : setUserIsMobile(false);
  }, [userIsMobile]);
  const [menuOpen, setMenuOpen] = useState(false);
  useEffect(() => {
    if (messages.length > 0 && room?.localParticipant != null) {
      // //console.log(messages[messages.length - 1]?.body?.split('/')[1], 'checking wala data');
      if (messages[messages.length - 1]?.body?.split('/')[0] == 'disconnectedall') {
        // if (audioTrack) {
        //   //console.log(audioTrack.isEnabled);
        //   audioTrack.disable();

        // }
        // //console.log(messages[messages.length - 1]?.body, 'chakdasdna');
        history.replace('/end');
        room!.disconnect();
        // //console.log("hello")
      }
    }
  }, [messages]);
  useEffect(() => {
    if (state) {
      //console.log(state, 'menu me state');
      if (ContactPhoneNumber && Type == 'Host') {
        setIsOpenCallOrSms(true);
        //console.log('chala data');

        // //console.log(state?.ContactNumber, "menu me state")
        // if (state!.state?.ContactNumber) {
        //   setIsOpenCallOrSms(true)
        //   //console.log("chala data")
        // }
      }
    } else {
      history.replace('/invalid');
      room!.disconnect();
    }
  }, [state]);
  const openDialpadModal = () => {
    setIsDialpadModalOpen(true);
  };
  const openOpenCallOrSmsl = () => {
    setIsOpenCallOrSms(true);
  };

  const closeOpenCallOrSms = () => {
    setIsOpenCallOrSms(false);
  };
  const closeDialpadModal = () => {
    setIsDialpadModalOpen(false);
  };

  const openSmsModal = () => {
    setIsSmsModalOpen(true);
  };

  const closeSmsModal = () => {
    setIsSmsModalOpen(false);
  };

  const openisListOpenModal = () => {
    setisListOpen(true);
  };

  const closeListModal = () => {
    setisListOpen(false);
  };

  return (
    <>
      {isSharingScreen && (
        <Grid container justifyContent="center" alignItems="center" className={classes.screenShareBanner}>
          <Typography variant="h6">You are sharing your screen</Typography>
          <Button onClick={() => toggleScreenShare()}>Stop Sharing</Button>
        </Grid>
      )}

      <footer className={classes.container} id="desktops">
        <Grid container justifyContent="space-around" alignItems="center" className="formobcss">
          <div className="container footmenu">
            <div className="row">
              <div className="col-sm-3">
                {/* <Hidden smDown>
            <Grid style={{ flex: 1 }}>
              <Typography variant="body1">
                {room!.name} | {participants.length + 1} participant{participants.length ? 's' : ''}
              </Typography>
            </Grid>
          </Hidden> */}
                {Type == 'Host' ? (
                  <>
                    <Button onClick={openDialpadModal}>
                      <img src={Dailer} alt="asd" /> <p>Dialer</p>
                    </Button>
                    <Button onClick={openSmsModal}>
                      <img src={SMS} alt="asd" /> <p>SMS</p>
                    </Button>
                  </>
                ) : (
                  <></>
                )}
              </div>

              <div className="col-sm-6">
                <Grid item>
                  <Grid container justifyContent="center" id="mylines">
                    <Button onClick={openisListOpenModal}>
                      <img src={Participants} alt="as" /> <p>Participants</p>
                    </Button>
                    {userIsMobile == false ? (
                      <Fragment>
                        <span className="audioon">
                          <ToggleAudioButton disabled={isReconnecting} />
                        </span>
                        <span className="audioff">
                          <ToggleVideoButton disabled={isReconnecting} />
                        </span>
                      </Fragment>
                    ) : (
                      <></>
                    )}

                    {!isSharingScreen && !isMobile && <ToggleScreenShareButton disabled={isReconnecting} />}
                    {process.env.REACT_APP_DISABLE_TWILIO_CONVERSATIONS !== 'true' && <ToggleChatButton />}
                    {/* <Hidden smDown>
                <Menu />
              </Hidden> */}
                  </Grid>
                </Grid>
              </div>

              <div className="col-sm-3 lasts">
                {/* <Hidden smDown>
                  <Grid style={{ flex: 1 }}>
                    <Grid container justifyContent="flex-end">
                      <EndCallButton />
                    </Grid>
                  </Grid>
                </Hidden> */}
                {Type == 'Host' ? (
                  <button>
                    {roomType !== 'peer-to-peer' && roomType !== 'go' && (
                      <MenuItem
                        disabled={isFetching}
                        onClick={() => {
                          setMenuOpen(false);
                          if (isRecording) {
                            updateRecordingRules(room!.sid, [{ type: 'exclude', all: true }]);
                          } else {
                            updateRecordingRules(room!.sid, [{ type: 'include', all: true }]);
                          }
                        }}
                        data-cy-recording-button
                      >
                        <div className="recording">
                          <img src={Record} alt="as" />
                          {/* <IconContainer>{isRecording ? <StopRecordingIcon /> : <img src={Record} alt="as" />}</IconContainer> */}
                          <Typography variant="body1">{isRecording ? 'Stop' : 'Start'} Recording</Typography>
                        </div>
                      </MenuItem>
                    )}
                  </button>
                ) : (
                  <></>
                )}
                <Menu />
              </div>
            </div>
          </div>
        </Grid>
      </footer>

      {/* formobile */}

      <footer className={classes.container} id="mobiles">
        <button
          className="offcanbtn"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#staticBackdrop"
          aria-controls="staticBackdrop"
        >
          +
        </button>
        {userIsMobile == true ? (
          <>
            <div className="audi1">
              <ToggleAudioButton disabled={isReconnecting} />
            </div>

            <div className="audi2">
              <ToggleVideoButton disabled={isReconnecting} />
            </div>
          </>
        ) : (
          <></>
        )}

        <div
          className="offcanvas offcanvas-start"
          data-bs-backdrop="static"
          id="staticBackdrop"
          aria-labelledby="staticBackdropLabel"
        >
          <div className="offcanvas-header">
            <h5 className="offcanvas-title" id="staticBackdropLabel">
              {' '}
              Menu{' '}
            </h5>
            <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
          </div>
          <div className="offcanvas-body">
            <div>
              <div className="row">
                <div className="col-sm-12">
                  {Type == 'Host' ? (
                    <Button onClick={openDialpadModal}>
                      <img src={Dailer} alt="asd" /> <p>Dialer</p>
                    </Button>
                  ) : (
                    <></>
                  )}
                  {/* <Button onClick={openDialpadModal}>
                    <img src={Dailer} alt="asd" /> <p>Dialer</p>
                  </Button> */}
                </div>
                <div className="col-sm-12">
                  {Type == 'Host' ? (
                    <Button onClick={openSmsModal}>
                      <img src={SMS} alt="asd" /> <p>SMS</p>
                    </Button>
                  ) : (
                    <></>
                  )}
                  {/* <Button onClick={openSmsModal}>
                    <img src={SMS} alt="asd" /> <p>SMS</p>
                  </Button> */}
                </div>

                <div className="col-sm-12">
                  <Button onClick={openisListOpenModal}>
                    <img src={Participants} alt="as" /> <p>Participants</p>
                  </Button>
                </div>

                <div className="col-sm-12">{/* <ToggleAudioButton disabled={isReconnecting} /> */}</div>

                <div className="col-sm-12">{/* <ToggleVideoButton disabled={isReconnecting} /> */}</div>

                <div className="col-sm-12">
                  {!isSharingScreen && !isMobile && <ToggleScreenShareButton disabled={isReconnecting} />}
                </div>

                <div className="col-sm-12">{Type == 'Host' ? <Menu /> : <></>}</div>
                <div className="col-sm-12">
                  <button>
                    {Type == 'Host' ? (
                      <button>
                        {roomType !== 'peer-to-peer' && roomType !== 'go' && (
                          <MenuItem
                            disabled={isFetching}
                            onClick={() => {
                              setMenuOpen(false);
                              if (isRecording) {
                                updateRecordingRules(room!.sid, [{ type: 'exclude', all: true }]);
                              } else {
                                updateRecordingRules(room!.sid, [{ type: 'include', all: true }]);
                              }
                            }}
                            data-cy-recording-button
                          >
                            <div className="recording">
                              <img src={Record} alt="as" />
                              {/* <IconContainer>{isRecording ? <StopRecordingIcon /> : <img src={Record} alt="as" />}</IconContainer> */}
                              <Typography variant="body1">{isRecording ? 'Stop' : 'Start'} Recording</Typography>
                            </div>
                          </MenuItem>
                        )}
                      </button>
                    ) : (
                      <></>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-sm-12 chatsbox">
          {process.env.REACT_APP_DISABLE_TWILIO_CONVERSATIONS !== 'true' && <ToggleChatButton />}
        </div>
      </footer>

      <Dialog open={isDialpadModalOpen} onClose={closeDialpadModal} className="dailpadhassan">
        <Button onClick={closeDialpadModal} id="closebutton">
          X
        </Button>
        {/* <DialogTitle>Make A Call</DialogTitle> */}
        <DialogContent>
          {/* You can place the content of your dialpad modal here */}
          <Dailpad />
        </DialogContent>
      </Dialog>

      <Dialog open={isSmsModalOpen} onClose={closeSmsModal} className="dailpadhassan">
        <Button onClick={closeSmsModal} id="closebutton">
          X
        </Button>
        {/* <DialogTitle>Make A Call</DialogTitle> */}
        <DialogContent>
          {/* You can place the content of your dialpad modal here */}
          <SmsInvite />
        </DialogContent>
      </Dialog>
      {NumberAvailable === true ? (
        <Dialog open={isOpenCallOrSms} onClose={closeOpenCallOrSms} className="dailpadhassan">
          <Button onClick={closeOpenCallOrSms} id="closebutton">
            X
          </Button>

          <DialogContent>
            <OpenCallOrSms />
          </DialogContent>
        </Dialog>
      ) : (
        <></>
      )}

      <Dialog open={isListOpen} onClose={closeListModal} className="participants">
        <Button onClick={closeListModal} id="closebutton">
          Close
        </Button>
        {/* <DialogTitle>Make A Call</DialogTitle> */}
        <DialogContent>
          <img src={Logo} alt="" />
          <h3 className="partlist">Participants</h3>
          {/* You can place the content of your dialpad modal here */}
          <ParticipantsList />
        </DialogContent>
      </Dialog>
    </>
  );
}
export {};
